var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d751a823b3a654c5c58285fdce8ff39776ac1e6a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["watchman-frontend@gits-id"]={id:"d751a823b3a654c5c58285fdce8ff39776ac1e6a"};
      